// extracted by mini-css-extract-plugin
export var isPrintedCell = "_wx-1";
export var printerIcon = "_wx-0";